import { createFileRoute } from "@tanstack/react-router";

import { FAQContainer } from "@/features/faq/containers/faq-container";

export const Route = createFileRoute("/app/faq")({
  component: FAQContainer,
});
